var exports = {
  "x6": "DiscoveryButton.module__button___Z1paME",
  "td": "DiscoveryButton.module__iconText___Z1paME",
  "yF": "DiscoveryButton.module__iconTextSelected___Z1paME",
};

module.exports = exports;
